const getReviewStarInputIcon = ({ number, value, hoveredValue, isHovered }) => {
  const isEmpty = value === 0
  const isLowerThanHovered = number <= hoveredValue
  const isLowerThanModel = number <= value

  const isHighlighted =
    (isEmpty && isLowerThanHovered) ||
    (!isEmpty && (isHovered ? isLowerThanHovered : isLowerThanModel))

  const variant = isEmpty ? 'fa-regular' : 'fa-solid'
  const color = isHighlighted ? 'tw-text-[#F2BF08]' : 'tw-text-spf-disabled'

  return `${variant} ${color}`
}

export default getReviewStarInputIcon
